import React from 'react';
import { FiTrash } from 'react-icons/fi';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { Button } from '@mantine/core';


interface ModalRemoveProps {
  title?: string;
  loading?: boolean;
  isVisible: boolean;
  cancelText?: string;
  confirmationText?: string;
  onClose: () => void;
  onConfirmation: () => void;
  data?: any;
}

const ModalRemove: React.FC<ModalRemoveProps> = ({
  isVisible,
  onClose,
  onConfirmation,
  title,
  loading,
  cancelText,
  confirmationText,
  data
}) => {
     const handleCancel = () => {
      if(data.Status !== '001'){
        data.Status = '001'
      }
      onClose()
     }
  return (
    <ModalWrapper
      title={`${title + " Delegation"}`}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className="wrapper-modal-delete">
        <div className="wrapper-modal-delete__content">
          <p className="m-0"> 
            you can't activate this delegation after <span style={{ textTransform: 'lowercase' }}>{title}</span> this delegation. Are you sure want to
            <span style={{ textTransform: 'lowercase' }}>{" " + title}</span> delegation ?
          </p>
          <div className="wrapper-modal-delete__content__actions">
            <Button onClick={() => handleCancel()} color='red'>
              {cancelText || 'Cancel'}
            </Button>
            <Button
              disabled={loading}
              loading={loading}
              color='purple'
              onClick={() => onConfirmation()}
            >
              {confirmationText || (
                <>
                  Submit
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ModalRemove;
